const data = {
  title: "Floor 5-4",
  musicTrack: "MUSIC_WORLD1",
  theme: "YELLOW",
  tilesWidth: 10,
  tilesHeight: 17,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 2,
    },
    {
      type: "WATER",
      x: 4,
      y: 1,
    },
    {
      type: "WATER",
      x: 5,
      y: 1,
    },
    {
      type: "WATER",
      x: 5,
      y: 2,
    },
    {
      type: "WATER",
      x: 4,
      y: 2,
    },
    {
      type: "WATER",
      x: 4,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 3,
    },
    {
      type: "WATER",
      x: 5,
      y: 4,
    },
    {
      type: "WATER",
      x: 4,
      y: 4,
    },
    {
      type: "WATER",
      x: 6,
      y: 6,
    },
    {
      type: "WATER",
      x: 5,
      y: 6,
    },
    {
      type: "WATER",
      x: 5,
      y: 7,
    },
    {
      type: "WATER",
      x: 6,
      y: 7,
    },
    {
      type: "WATER",
      x: 6,
      y: 9,
    },
    {
      type: "WATER",
      x: 7,
      y: 9,
    },
    {
      type: "WATER",
      x: 7,
      y: 11,
    },
    {
      type: "WATER",
      x: 6,
      y: 11,
    },
    {
      type: "WATER",
      x: 7,
      y: 12,
    },
    {
      type: "WATER",
      x: 7,
      y: 14,
    },
    {
      type: "WATER",
      x: 7,
      y: 13,
    },
    {
      type: "WATER",
      x: 8,
      y: 12,
    },
    {
      type: "WATER",
      x: 8,
      y: 13,
    },
    {
      type: "WATER",
      x: 8,
      y: 14,
    },
    {
      type: "WATER",
      x: 8,
      y: 16,
    },
    {
      type: "WATER",
      x: 8,
      y: 15,
    },
    {
      type: "WATER",
      x: 9,
      y: 15,
    },
    {
      type: "WATER",
      x: 9,
      y: 16,
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 10,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 6,
      y: 5,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 5,
      y: 5,
      direction: "LEFT",
    },
    {
      type: "WALL",
      x: 1,
      y: 6,
    },
    {
      type: "WALL",
      x: 2,
      y: 8,
    },
    {
      type: "WALL",
      x: 2,
      y: 14,
    },
    {
      type: "SWITCH_WALL",
      x: 6,
      y: 8,
      isRaised: true,
    },
    {
      type: "SWITCH",
      x: 3,
      y: 17,
    },
    {
      type: "WALL",
      x: 5,
      y: 15,
    },
    {
      type: "WALL",
      x: 6,
      y: 16,
    },
    {
      type: "WALL",
      x: 6,
      y: 17,
    },
    {
      type: "LOCK",
      x: 10,
      y: 17,
      color: "BLUE",
    },
    {
      type: "CHIP",
      x: 5,
      y: 17,
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 12,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 6,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 1,
      direction: "DOWN",
      enemyType: "FLYING_ENEMY",
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 11,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 13,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 12,
      direction: "DOWN",
    },
    {
      type: "FIRE",
      x: 1,
      y: 14,
    },
    {
      type: "FIRE_BOOTS",
      x: 9,
      y: 2,
    },
    {
      type: "CHIP",
      x: 10,
      y: 16,
    },
    {
      type: "CHIP",
      x: 8,
      y: 17,
    },
    {
      type: "CONVEYOR",
      x: 7,
      y: 17,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 9,
      y: 17,
      direction: "LEFT",
    },
    {
      type: "CHIP",
      x: 1,
      y: 11,
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 10,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 9,
      direction: "DOWN",
    },
    {
      type: "CONVEYOR",
      x: 1,
      y: 8,
      direction: "DOWN",
    },
    {
      type: "WALL",
      x: 2,
      y: 11,
    },
    {
      type: "WALL",
      x: 2,
      y: 10,
    },
    {
      type: "WALL",
      x: 2,
      y: 9,
    },
    {
      type: "WALL",
      x: 2,
      y: 12,
    },
    {
      type: "WALL",
      x: 2,
      y: 13,
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 4,
      direction: "RIGHT",
      enemyType: "ENEMY",
    },
    {
      type: "WALL",
      x: 8,
      y: 7,
    },
    {
      type: "WALL",
      x: 10,
      y: 10,
    },
    {
      type: "WALL",
      x: 9,
      y: 12,
    },
    {
      type: "ICE",
      x: 9,
      y: 7,
    },
    {
      type: "ICE",
      x: 9,
      y: 9,
    },
    {
      type: "ICE",
      x: 9,
      y: 8,
    },
    {
      type: "ICE",
      x: 8,
      y: 8,
    },
    {
      type: "ICE",
      x: 8,
      y: 9,
    },
    {
      type: "ICE",
      x: 7,
      y: 8,
    },
    {
      type: "ENEMY_SPAWN",
      x: 1,
      y: 16,
      direction: "RIGHT",
      enemyType: "FLYING_ENEMY",
    },
    {
      type: "KEY",
      x: 6,
      y: 1,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 1,
      y: 1,
    },
    {
      type: "WALL",
      x: 3,
      y: 1,
    },
    {
      type: "WALL",
      x: 10,
      y: 1,
    },
    {
      type: "FIRE",
      x: 1,
      y: 3,
    },
    {
      type: "FIRE",
      x: 2,
      y: 4,
    },
    {
      type: "FIRE",
      x: 1,
      y: 5,
    },
    {
      type: "CHIP",
      x: 1,
      y: 4,
    },
  ],
};

export default data;
